import {Component, EventEmitter, Input, Output} from '@angular/core';
import {JaversSnapshot} from '../../../javers/javers-snapshot';
import {ADDomain, ADGroup, CustomerGroup, ManagerUser, SubProject} from '../../../models';
import {AdGroupDaoService} from '../../ad-group/ad-group-dao.service';
import {StatusService} from '../status-service';
import {Observable} from 'rxjs/internal/Observable';
import {of} from 'rxjs/internal/observable/of';

@Component({
    selector: 'app-ad-group-snapshots',
    templateUrl: './ad-group-snapshots.component.html',
    styleUrls: ['./ad-group-snapshots.component.scss', '../status.component.scss']
})
export class AdGroupSnapshotsComponent {

    public adGroupsSnapshots: JaversSnapshot<ADGroup>[];

    @Input()
    adDomains: ADDomain[] = [];

    @Input()
    managerUsers: ManagerUser[] = [];

    @Input()
    customerGroups: CustomerGroup[] = [];

    @Input()
    subProjects: SubProject[] = [];

    @Input()
    adGroups: ADGroup[];

    @Output()
    adGroupsRead: EventEmitter<ADGroup[]> = new EventEmitter();


    loading = false;
    alreadyRead = false;


    constructor(private adGroupDaoService: AdGroupDaoService, public statusServer: StatusService) {

    }


    getData(): void {
        this.loading = true;
        this.alreadyRead = true;
        this.getAdGroups().subscribe(adGroups => {
            this.adGroupsRead.emit(adGroups);
            this.adGroupDaoService.snapshotsLimit(5).subscribe((adGroupsSnapshots) => {
                this.loading = false;
                this.adGroupsSnapshots = adGroupsSnapshots;
            });
        });

    }

    getAdGroups(): Observable<ADGroup[]> {
        this.adGroupDaoService.get().subscribe((adGroups) => {
            this.adGroups = adGroups;
        });
        if (!this.adGroups || this.adGroups?.length < 1 || this.alreadyRead) {
            console.log('getAdGroups()');
            return this.adGroupDaoService.get();
        }
        return of(this.adGroups);
    }
}
